// R8-1 — THE ATTACHMENT URL, LIFTED OUT OF App.tsx VERBATIM.
//
// One line, and it is a LAW rather than a helper: this string IS the contract between the thread's
// rendered <img>/<a> and the server's auth-gated file route. Get it wrong and every attachment in
// every reopened conversation renders a broken image — with no error anywhere, because a 404 on an
// <img src> is silent.
//
// It moves ahead of `MessageAttachments` (R8-3) because that component cannot leave App.tsx without
// it, and it lands in `src/lib` rather than beside the component because it is a pure law with no
// JSX in it — so the R5 loader can reach it directly, and the gate can hold it against the REAL
// route in `server/index.js`, which is the only check on it worth having.
//
// Moved VERBATIM.
export function attachmentUrl(id: string) { return `/api/lala/attachment/${id}`; }

// W2-3 pays for its App.tsx lines by moving this here, and it belongs here on its own merits: it is
// the READ side of the same contract `attachmentUrl` is the write side of. The saved message text
// carries an "[attached: ...]" note so a later turn still knows a file was there; the thread renders
// the real previews instead, so the note is stripped from the bubble. Both Lala surfaces call it, and
// until now neither one could be held to calling the same version of it.
//
// Moved VERBATIM.
export function stripAttachNote(text: string) {
  return String(text || "").replace(/\n*\[attached:[^\]]*\]\s*$/i, "").trim();
}
